import { render } from "./page-search.vue?vue&type=template&id=22eeef6c&scoped=true&ts=true"
import script from "./page-search.vue?vue&type=script&lang=ts"
export * from "./page-search.vue?vue&type=script&lang=ts"

import "./page-search.vue?vue&type=style&index=0&id=22eeef6c&lang=less&scoped=true"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22eeef6c"]])

export default __exports__